<!--申请人信息-->
<template>
  <div class="module">
    <h5 class="module-title">申请人信息</h5>
    <div class="module-tips">申请人只能为易派客管理员，请补充相关信息</div>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="申请人：" prop="name" label-width="96px">
            {{ defaultForm.creatorRealName }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="易派客用户名：" prop="region">
            {{ defaultForm.creator }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="证件信息："
            :prop="`accountUserApplicantAttachAOList[${getIndexByFileType(
              'AC'
            )}].certificateNo`"
            :rules="rules.certificateNo"
            label-width="96px"
            class="document-information"
          >
            <el-select
              v-model="
                ruleForm.accountUserApplicantAttachAOList[
                  getIndexByFileType('AC')
                ].certificateType
              "
              placeholder="请选择"
            >
              <el-option
                v-for="item in certificateTypeList"
                :key="item.itemCode"
                :label="item.itemDisp"
                :value="item.itemCode"
              ></el-option>
            </el-select>
            <el-input
              v-model="
                ruleForm.accountUserApplicantAttachAOList[
                  getIndexByFileType('AC')
                ].certificateNo
              "
              placeholder="请输入证件号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="证件有效期："
            :rules="rules.certificateTimeRange"
            :prop="`accountUserApplicantAttachAOList[${getIndexByFileType(
              'AC'
            )}].certificateTimeRange`"
            label-width="96px"
            class="period-of-validity"
          >
            <el-date-picker
              v-model="
                ruleForm.accountUserApplicantAttachAOList[
                  getIndexByFileType('AC')
                ].certificateTimeRange
              "
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :disabled="createrDateDisabled"
            >
            </el-date-picker>
            <el-checkbox
              v-model="
                ruleForm.accountUserApplicantAttachAOList[
                  getIndexByFileType('AC')
                ].isLongTernEffective
              "
              @change="radioChange('AC', 'accountUserApplicantAttachAOList')"
              >长期有效
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="证件复印件："
            prop="applyCertificate"
            :rules="rules.attachPath"
            label-width="96px"
          >
            <div class="flex">
              <eui-upload
                ref="euiUpload1"
                key-name="applicantCertificatePath"
                :file-list="fileList.AC"
                :action="uploadPayCenterFile"
                :private-upload="privateUpload"
                :headers="headers"
                :show-file-list="true"
                accept=".jpg,.png"
                single
                text="上传附件"
                @handleSuccess="() => uploadSuccess('AC', fileList.AC)"
              >
              </eui-upload>
              <eui-btn type="secondary" @click="previewUploadFile(fileList.AC)"
                >预览
              </eui-btn>
              <span
                >请上传身份证证件两面清晰的扫描或复印件，并加盖公司红色公章，限≤2mb，jpg、png格式。</span
              >
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="授权书："
            prop="applyEmpower"
            :rules="rules.attachPath"
            label-width="96px"
          >
            <div>1.下载授权书模板：</div>
            <div style="margin-top: -10px" class="gray-color">
              <span
                style="color: #0064c8; cursor: pointer"
                @click="downloadTemplate()"
                >点击下载《申请人授权书模板》</span
              >
              下载后填写相关信息，申请人签字、加盖公章，并扫描后上传
            </div>
            <div>2.上传扫描件：</div>
            <div class="flex">
              <eui-upload
                ref="euiUpload2"
                :file-list="fileList.AA"
                :action="uploadPayCenterFile"
                :private-upload="privateUpload"
                :headers="headers"
                :show-file-list="true"
                single
                accept=".jpg,.png,.pdf"
                text="上传文件"
                :picure-width="200"
                tip="请上传清晰的扫描或复印件并加盖公司公章(红色)。限≤2mb，jpg、png、pdf格式"
                @handleSuccess="() => uploadSuccess('AA', fileList.AA)"
              >
              </eui-upload>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <viewer-image
      ref="viewer"
      :preview-src-list="[dialogPicUrl]"
    ></viewer-image>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import { idCardReg } from '@/modules/projectA/utils/verification';
import {
  commonMethodsMixins,
  uploadPayCenterFile,
  headers,
  privateUpload,
  certificateTypeList,
  downloadTemplateUrl,
} from '../constant';
import ViewerImage from '../components/viewerImage';

export default {
  name: 'ApplicationInfo',
  components: { ViewerImage },
  mixins: [commonMethodsMixins],
  data() {
    return {
      defaultForm: {
        creatorRealName: '', // 申请人姓名
        creator: '', // 易派客用户名
      },
      ruleForm: {
        accountUserApplicantAttachAOList: [
          {
            attachName: '',
            attachPath: '',
            attachType: 'AC',
            certificateNo: '',
            certificateType: 0,
            certificateValidityBegin: '',
            certificateValidityEnd: '',
            certificateTimeRange: [],
            isLongTernEffective: null,
          },
          {
            attachName: '',
            attachPath: '',
            attachType: 'AA',
          },
        ],
      },
      fileList: {
        AC: [],
        AA: [],
      },
      dialogPicUrl: '',
      createrDateDisabled: false,
      uploadPayCenterFile,
      headers,
      // 私有仓库得地址
      privateUpload,
      reUploadFlag: false, // 是否重新上传
      certificateTypeList,
      rules: {
        certificateNo: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              const obj = this.ruleForm.accountUserApplicantAttachAOList[0];
              if (!value) {
                callback('请输入证件号码');
              } else if (!idCardReg.test(value) && obj.certificateType === 0) {
                callback('证件号码格式错误');
              } else {
                const res = await Api.checkEpaySettleAccountUserIDNumberUnique({
                  certificateType: obj.certificateType,
                  iDNumber: obj.certificateNo,
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
        certificateTimeRange: [
          { required: true, message: '请选择证件有效期', trigger: 'change' },
        ],
        attachPath: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              switch (rule.field) {
                // 申请人身份证件
                case 'applyCertificate':
                  if (!this.fileList.AC.length) {
                    callback('请上传');
                  }
                  break;
                // 申请人授权书
                case 'applyEmpower':
                  if (!this.fileList.AA.length) {
                    callback('请上传');
                  }
                  break;
                // 法人身份证件
                case 'legalPersonCertificate':
                  if (!this.fileList.LRC.length) {
                    callback('请上传');
                  }
                  break;
                // 经办员身份证件
                case 'operatorCertificate':
                  if (!this.userFileList[0].UC.length) {
                    callback('请上传');
                  }
                  break;
                // 审核员身份证件
                case 'auditorCertificate':
                  if (
                    !this.userFileList[1].UC.length &&
                    this.activeTab === '2'
                  ) {
                    callback('请上传');
                  }
                  break;
                // 个人信息处理告知同意书
                case 'notificationLetter':
                  if (!this.userFileList[1].PPN.length) {
                    callback('请上传');
                  }
                  break;
                default:
                  if (!value) {
                    callback('请上传');
                  }
                  break;
              }
              callback();
            },
            trigger: 'change',
          },
        ],
      },
    };
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const res = await Api.getEpayAccountApplicant();
      if (res.success) {
        this.defaultForm.creator = res.data?.creator;
        this.defaultForm.creatorRealName = res.data?.creatorRealName;
        this.ruleForm.accountUserApplicantAttachAOList.forEach(
          (attachItem, index) => {
            const tempObj = res.data.applicantAttachVOList.find(
              (tempItem) => tempItem.attachType === attachItem.attachType
            );
            if (tempObj) {
              Object.keys(attachItem).forEach((key) => {
                attachItem[key] = tempObj[key] ?? attachItem[key];
              });
              // 附件回显
              if (attachItem?.attachName && attachItem?.attachPath) {
                this.fileList[attachItem.attachType].push({
                  name: attachItem.attachName,
                  url: attachItem.attachPath,
                });
              }
              if (attachItem.attachType === 'AC') {
                attachItem.certificateTimeRange =
                  attachItem.certificateBeginTime &&
                  attachItem.certificateEndTime
                    ? [
                        attachItem.certificateBeginTime,
                        attachItem.certificateEndTime,
                      ]
                    : [];
                attachItem.certificateValidityEnd =
                  !!attachItem.certificateValidityEnd;
              }
              this.$set(
                this.ruleForm.accountUserApplicantAttachAOList,
                index,
                attachItem
              );
            }
          }
        );
      }
      console.log(this.ruleForm, 'applicant init');
      this.radioChange('AC', 'accountUserApplicantAttachAOList');
    },
    // 证件有效期值改变
    radioChange(certificateType, objName = 'settleAccountAttachTempList') {
      const index = this.getIndexByFileType(certificateType);
      const certificateObj = this.ruleForm[objName][index];
      this.$nextTick(() => {
        switch (certificateType) {
          // 申请人证件有效期
          case 'AC':
            if (
              certificateObj?.certificateLongValid ||
              certificateObj?.isLongTernEffective
            ) {
              this.rules.certificateTimeRange[0].required = false;
              this.$refs['ruleForm'].resetFields();
              this.createrDateDisabled = true;
              // 开户申请
              if (certificateObj?.certificateBeginTime) {
                certificateObj.certificateBeginTime = '';
              }
              // 开户申请
              if (certificateObj?.certificateEndTime) {
                certificateObj.certificateEndTime = '';
              }
              // 补办ukey
              if (certificateObj?.certificateValidityBegin) {
                certificateObj.certificateValidityBegin = '';
              }
              // 补办ukey
              if (certificateObj?.certificateValidityEnd) {
                certificateObj.certificateValidityEnd = '';
              }
              certificateObj.certificateTimeRange = [];
            } else {
              this.rules.certificateTimeRange[0].required = true;
              this.createrDateDisabled = false;
            }
            break;
          default:
            break;
        }
      });
    },
    // 下载模板
    async downloadTemplate() {
      const path = `${downloadTemplateUrl}/%E6%8E%88%E6%9D%83%E4%B9%A6%E6%A8%A1%E6%9D%BF.doc`;
      window.open(path);
    },
    // 法人和申请人附件上传
    uploadSuccess(certificateType, attachObj) {
      this.reUploadFlag = true;
      const tempObj = this.ruleForm.accountUserApplicantAttachAOList.find(
        (attach) => attach.attachType === certificateType
      );

      if (tempObj) {
        this.$set(tempObj, 'attachName', attachObj[0]?.response?.data.fileName);
        this.$set(tempObj, 'attachPath', attachObj[0]?.response?.data.url);
        if (certificateType === 'AA' || certificateType === 'AC') {
          Api.addEpaySettleAccountApplicantAttach({
            attachName: attachObj[0]?.response?.data.fileName,
            attachPath: attachObj[0]?.response?.data.url,
            attachType: certificateType,
          });
        }
      }

      console.log(
        this.ruleForm.accountUserApplicantAttachAOList,
        'accountUserApplicantAttachAOList111111111'
      );
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
    // 获取附件信息下标
    getIndexByFileType(type, list) {
      const sourceData =
        list ?? this.ruleForm?.accountUserApplicantAttachAOList;
      return sourceData?.findIndex((item) => item.attachType === type);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/common.scss';
</style>
